/**
 * Do not edit this file it is auto-generated by io-utils / gen-api-models.
 * See https://github.com/pagopa/io-utils
 */
/* eslint-disable  */

import * as t from "io-ts";

/**
 * Order session payment gatewa identifier
 */

export type OrderId = t.TypeOf<typeof OrderId>;
export const OrderId = t.string;
